<template>
  <div class="goods-content">
    <searchHeader @goback="gotoClassify" @search-goods="searchGoods"></searchHeader>
    <div class="goods-list">
      <van-pull-refresh v-model="downloading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <div>
            <div
              class="goods-item-box van-clearfix"
              v-for="(item, index) in goodsList"
              :key="index"
              @click="gotoDetail(item)"
            >
              <div class="goods-left-img">
                <img v-bind:src="item.goodsBannerPicUrl" alt="" />
              </div>
              <div class="goods-right-info">
                <div class="goods-info-name over2line">{{ item.name }}</div>
                <goodsPrice :price="item.price"></goodsPrice>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div class="backc-to-top" v-show="showBackBtn" @click="backToTop"></div>
      <van-loading class="data-loading" color="#45C5DA" v-show="showLoading" />
    </div>
  </div>
</template>
<script>
import api from 'api/goods-list';
import searchHeader from 'components/search-header';
export default {
  components: {
    searchHeader,
  },
  data() {
    return {
      typeId: '',
      page: {
        pageSize: 6,
        pageNumber: 1,
      },
      goodsList: [],
      noDate: false,
      showBackBtn: false,
      loading: false, //是否在加载数据
      downloading: false, //是否在加载数据
      finished: false, //是否已加载全部数据
      goodsName: '',
      showLoading: false,
      supplierId: '',//供应商id
    };
  },
  created() {
    if (this.$route.query.goodsType) {
      this.typeId = this.$route.query.goodsType;
    }else if (this.$route.query.goodsName){
      this.goodsName = this.$route.query.goodsName;
    }else if (this.$route.query.supplierId) {
      this.supplierId = this.$route.query.supplierId;
    }
    this.getGoodsList();
  },
  mounted() {
    //设置返回顶部图标的显隐切换，使用IntersectionObserver构造函数
    this.observe = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.showBackBtn = false;
      } else {
        this.showBackBtn = true;
      }
      this.$forceUpdate();
    });
  },
  methods: {
    gotoClassify() {
      if (this.$route.query.from && this.$route.query.from === 'home') {
        this.$router.push({
          name: 'home',
        });
      }else{
        this.$router.push({
          name: 'classify',
        });
      }
    },
    async getGoodsList() {
      let data;
      this.showLoading = true;
      //按名称筛选
      if (this.goodsName) {
        let params = {
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
          key: this.goodsName
        }
        data = await api.getGoodsByName(params);
      } else{
        let params = {
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
        }
        //按分类筛选
        if (this.typeId) {
          params.typeLevel = 2, //二级分类
          params.goodsTypeId = this.typeId
        }else if (this.supplierId) {
          //按供应商筛选
          params.supplierId = this.supplierId;
        }
        data = await api.getGoodsList(params);
      }
      this.showLoading = false;
      this.loading = false; //加载完成
      this.downloading = false; //加载完成
      this.finished = data.records.length < this.page.pageSize; //是否是最后几条数据了
      if (this.page.pageNumber === 1) {
        this.goodsList = data.records;
      } else {
        this.goodsList = this.goodsList.concat(data.records);
      }
      //等待选然后对元素可见性进行监听，用于返回顶部图标的显隐切换
      if (this.goodsList.length > 4) {
        this.$nextTick(function() {
          //终止对所有目标元素可见性变化的观察
          this.observe.disconnect();
          this.observe.observe(document.getElementsByClassName('goods-item-box')[4]);
        });
      }
    },
    //下拉刷新
    onRefresh() {
      this.page.pageNumber = 1;
      this.finished = false;
      this.goodsList = [];
      this.getGoodsList();
    },
    //加载
    onLoad() {
      this.$nextTick(function() {
        this.page.pageNumber++; //下拉一次页数+1
        this.getGoodsList();
      });
    },
    //返回顶部
    backToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    //前往详情页
    gotoDetail(item) {
      localStorage.setItem('goodsId', item.id);
      this.$router.push({
        path: '/goods-detail',
        query: { goodsId: item.id },
      });
    },
    searchGoods(name){
      this.goodsName = name;
      this.getGoodsList();
    }
  },
  filters: {
    formatPrice(val) {
      return Number(val).toFixed(2);
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'common/sass/theme.scss';
.goods-content {
  .goods-list {
    position: relative;
  }
  .goods-item-box {
    display: block;
    position: relative;
    background-color: #fff;
    height: 32vw;
    .goods-left-img {
      float: left;
      width: 32vw;
      height: 100%;
      padding: 5px;
      box-sizing: border-box;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .goods-right-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      float: left;
      width: 68vw;
      height: 100%;
      padding: 5px;
      border-bottom: 1px solid $light-line-color;
      box-sizing: border-box;
      .goods-info-name {
        font-size: 14px;
      }
      .goods-price {
        margin-top: 8px;
        color: $red-color;
      }
    }
  }
  .backc-to-top {
    position: fixed;
    right: 10px;
    bottom: 60px;
    width: 35px;
    height: 35px;
    background: url('../../assets/backtotop.png') no-repeat center/cover;
  }
}
</style>
